import { zodResolver } from '@hookform/resolvers/zod';
import { updateAccount } from 'api/account';
import Button from 'components/form/Button';
import { InputWithStyle } from 'components/form/Input';
import { TabContent } from 'components/layouts/TabComponent';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import useAccountStore from 'state/accountStore';
import { z } from 'zod';

interface WithdrawalSettingProps {
  currentTab: string;
}

const WithdrawalSettingSchema = z.object({
  // bank: z.object({
  //   name: z.string().min(3, 'name must be at least 3 characters'),
  //   accountName: z
  //     .string()
  //     .min(3, 'account name must be at least 3 characters'),
  //   accountNumber: z.string().min(8, 'account number is too short'),
  //   swiftCode: z.string().min(5, 'put a valid swift code'),
  // }),
  wallet: z.object({
    bitcoin: z.string().min(11, 'invalid address'),
    litecoin: z.string().min(11, 'invalid address'),
    ethereum: z.string().min(11, 'invalid address'),
    usdt: z.string().min(11, 'invalid address'),
  }),
});

type WithdrawalSettingSchemaType = z.infer<typeof WithdrawalSettingSchema>;

const Withdrawal = ({ currentTab }: WithdrawalSettingProps) => {
  const { account } = useAccountStore();
  const {
    control,
    formState: { isValid, isDirty, dirtyFields },
    handleSubmit,
  } = useForm<WithdrawalSettingSchemaType>({
    resolver: zodResolver(WithdrawalSettingSchema),
    mode: 'onTouched',
    defaultValues: {
      // bank: account?.bank,
      wallet: account?.wallet,
    },
  });

  const [loading, setLoading] = useState(false);

  const updateFunction = async (data: Partial<WithdrawalSettingSchemaType>) => {
    setLoading(true);
    try {
      const res = await updateAccount(data);

      if (res?.data) {
        toast.success('account updated');
      }
    } catch (error: any) {
      const { errors } = error.response.data;
      errors.map((err: { error: string }) => {
        return toast.error(err.error);
      });
      console.log(error);
    }
    setLoading(false);
  };

  const onSubmit = (data: WithdrawalSettingSchemaType) => {
    if (!account?.hasSetupAccount) {
      updateFunction(data);
      return;
    }
    const requestData: any = {};

    const keys = Object.keys(dirtyFields);
    for (const field of keys) {
      const value = data[field as keyof typeof data];
      requestData[field] = value;
    }
    updateFunction(requestData);
  };

  return (
    <TabContent tabId="tab2" currentTab={currentTab}>
      <form className="grid grid-cols-1 gap-y-4 py-3">
        {/* <div className="grid grid-cols-1 gap-8 pb-5 md:grid-cols-2">
          <label className="space-y-2">
            <div className="flex items-center space-x-2">
              <p className="font-bold capitalize">Bank name</p>
            </div>
            <InputWithStyle
              startIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                  />
                </svg>
              }
              type="text"
              name="bank.name"
              placeholder="bank name"
              control={control}
            />
          </label>
          <label className="space-y-2">
            <div className="flex items-center space-x-2">
              <p className="font-bold capitalize">Account Name</p>
            </div>
            <InputWithStyle
              startIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                  />
                </svg>
              }
              type="text"
              name="bank.accountName"
              placeholder="account name"
              control={control}
            />
          </label>
          <label className="space-y-2">
            <div className="flex items-center space-x-2">
              <p className="font-bold capitalize">Account number</p>
            </div>
            <InputWithStyle
              startIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"
                  />
                </svg>
              }
              type="number"
              name="bank.accountNumber"
              placeholder="account number"
              control={control}
            />
          </label>
          <label className="space-y-2">
            <div className="flex items-center space-x-2">
              <p className="font-bold capitalize">Swift code</p>
            </div>
            <InputWithStyle
              startIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"
                  />
                </svg>
              }
              type="text"
              name="bank.swiftCode"
              placeholder="swift code"
              control={control}
            />
          </label>
        </div> */}
        <div>
          <h4 className="my-2 text-lg">Crypto wallet addresses</h4>
          <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2">
            <label className="space-y-2">
              <div className="flex items-center space-x-2">
                <p className="font-bold capitalize">Bitcoin</p>
              </div>
              <InputWithStyle
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                }
                type="text"
                name="wallet.bitcoin"
                placeholder="bitcoin address"
                control={control}
              />
            </label>
            <label className="space-y-2">
              <div className="flex items-center space-x-2">
                <p className="font-bold capitalize">Ethereum</p>
              </div>
              <InputWithStyle
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                }
                type="text"
                name="wallet.ethereum"
                placeholder="ethereum address"
                control={control}
              />
            </label>
            <label className="space-y-2">
              <div className="flex items-center space-x-2">
                <p className="font-bold capitalize">Litecoin</p>
              </div>
              <InputWithStyle
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                }
                type="text"
                name="wallet.litecoin"
                placeholder="litecoin address"
                control={control}
              />
            </label>
            <label className="space-y-2">
              <div className="flex items-center space-x-2">
                <p className="font-bold capitalize">Usdt TRC20</p>
              </div>
              <InputWithStyle
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                }
                type="text"
                name="wallet.usdt"
                placeholder="usdt address"
                control={control}
              />
            </label>
          </div>
          <br />
          <div className="flex w-full justify-end">
            <Button
              className="rounded-md bg-blue-500 px-3 py-2 text-white"
              disabled={!isDirty || !isValid || loading}
              loading={loading}
              onClick={handleSubmit(onSubmit)}
            >
              update
            </Button>
          </div>
        </div>
      </form>
    </TabContent>
  );
};

export default Withdrawal;
